import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const CircleDotIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/circle-dot"><g id="Icon"><path fillRule="evenodd" clipRule="evenodd" d="M12 21.5999C17.302 21.5999 21.6 17.3018 21.6 11.9999C21.6 6.69797 17.302 2.3999 12 2.3999C6.69809 2.3999 2.40002 6.69797 2.40002 11.9999C2.40002 17.3018 6.69809 21.5999 12 21.5999ZM4.40002 11.9999C4.40002 7.80254 7.80266 4.3999 12 4.3999C16.1974 4.3999 19.6 7.80254 19.6 11.9999C19.6 16.1973 16.1974 19.5999 12 19.5999C7.80266 19.5999 4.40002 16.1973 4.40002 11.9999Z" fill="currentColor" /><path d="M12 8.3999C10.0118 8.3999 8.40002 10.0117 8.40002 11.9999C8.40002 13.9881 10.0118 15.5999 12 15.5999C13.9883 15.5999 15.6 13.9881 15.6 11.9999C15.6 10.0117 13.9883 8.3999 12 8.3999Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CircleDotIcon;